import { ValidationService } from './../../../shared/services/validation.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { EmailDomainService } from './email-domain.service';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { EmailDomainModel } from '../../../models/master-data/email-domain.model';
import { AppMessages } from '../../../shared/constants/messages';

@Component({
    selector: 'modify-email-domain-popup',
    templateUrl: 'modify-email-domain-popup.component.html',
    providers: [EmailDomainService]
})

export class ModifyEmailDomainPopupComponent implements OnInit {
    public title: string;
    public emailDomainForm: FormGroup;
    public modifyEmailDomainModel = new EmailDomainModel();

    public isSuccess = false;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private emailDomainService: EmailDomainService,
        public dialogRef: MdDialogRef<ModifyEmailDomainPopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
        this.modifyEmailDomainModel.id = this.data.id;
        if (this.modifyEmailDomainModel.id) {
            this.title = 'Update Email Domain';
            this.emailDomainService.getEmailDomain(this.modifyEmailDomainModel.id).subscribe(
                (result) => {
                    if (result) {
                        const data = result.json();
                        this.modifyEmailDomainModel = data;

                    }
                }
            )
        } else {
            this.title = 'Add New Email Domain';
        }
    }

    createForm() {
        this.emailDomainForm = this.formBuilder.group({
            name: ['', [Validators.required, this.isValidEmailDomain]]
        });
    }

    isValidEmailDomain(formControl: AbstractControl) {
        let pattern = /^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (formControl.value && !pattern.test(formControl.value)) {
            return { 'invalidEmailDomain': true };
        }
        return null;
    }


    close() {
        this.dialogRef.close(this.isSuccess);
    }

    editEmailDomain() {
        const param = {
            id: this.modifyEmailDomainModel.id,
            name: this.modifyEmailDomainModel.name
        };
        this.emailDomainService.updateEmailDomain(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        );
    }

    onSubmit() {
        if (this.emailDomainForm.valid) {
            if (this.modifyEmailDomainModel.id) {
                this.editEmailDomain();
            } else {
                this.emailDomainService.addNewEmailDomain(this.emailDomainForm.value).subscribe(
                    (result) => {
                        if (result) {
                            const data = result.json();
                            this.dialogService.openSuccessDialog({ message: data.message });
                            this.isSuccess = true;
                            this.close();
                        }
                    }
                );
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/email-domain/modify-email-domain-popup.component.ts